// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/post-user-request-schema',
  type: 'object',
  required: ['userId', 'registrationType'],
  properties: {
    userId: {
      type: 'integer',
    },
    registrationType: {
      type: 'string',
      minLength: 1,
    },
  },
} as IJSONSchema;

export default schema;
